import {Component, OnInit, Input}        from '@angular/core';

declare var $: any;
import {SucursalService} from '../sucursal/sucursal.service';
import {Router} from '@angular/router';
import {ActivatedRoute} from '@angular/router';


import 'rxjs/Rx';

import myGlobals = require('../config');

@Component({
    selector: 'calibracion',
    template: require('../../app/calibracion/calibracion.component.html'),
    styles: [require('../../app/calibracion/calibracion.component.css')],
    directives: [],
})
export class CalibracionComponent implements OnInit {

    id: number;
    loading: boolean;

    constructor(private sucursalService: SucursalService,
                private router: Router, private route: ActivatedRoute) {
    }

    ngOnInit() {
        window.scrollTo(0, 0);

        this.loading = true;
        this.route.params.subscribe(params => {
            this.id = params['id'];

            //Enviar mail
            this.sucursalService.getPresupuestoCalibracion(this.id).subscribe(() => {
                this.loading = false;
                setTimeout(() => this.router.navigate(['/home']), 10000);
            });
        });
    }

    ngOnDestroy() {
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/calibracion/calibracion.component.ts